"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = __importDefault(require("@common/components/Modal"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var linkUtils_1 = require("@/react-app/common/utils/linkUtils");
var Button_1 = __importStar(require("../Button"));
function SecurityWarningModal(_a) {
    var setIsOpen = _a.setIsOpen, isOpen = _a.isOpen, link = _a.link;
    var t = (0, react_i18next_1.useTranslation)(['settings', 'common']).t;
    var handleProceed = function () {
        setIsOpen(false);
        (0, linkUtils_1.openLinkInNewTab)(link);
    };
    return (react_1.default.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen },
        react_1.default.createElement("div", { className: "security-warning-modal" },
            react_1.default.createElement("h3", { className: "title" }, t('settings:SECURITY.MODAL.TITLE')),
            react_1.default.createElement("p", { className: "margin-top mt-5" }, t('settings:SECURITY.MODAL.TEXT1')),
            react_1.default.createElement("p", { className: "margin-top" }, t('settings:SECURITY.MODAL.TEXT2')),
            react_1.default.createElement("p", { className: "margin-top" },
                t('settings:SECURITY.MODAL.HOSTNAME'),
                ": ",
                react_1.default.createElement("b", null, link && (0, linkUtils_1.extractHostnameFromLink)(link))),
            react_1.default.createElement("div", { className: "action-buttons" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Button_1.SecondaryButton, { text: t('common:COMMON.BTN.CANCEL'), onClick: function () { return setIsOpen(false); } }),
                    react_1.default.createElement(Button_1.default, { text: t('common:COMMON.BTN.PROCEED'), onClick: handleProceed }))))));
}
exports.default = SecurityWarningModal;
